import { useAnticipationStatus } from "@/hooks/useAnticipationStatus.ts";
import { useCharge } from "@/hooks/useCharge";
import { showToast } from "@/utils";
import { Button, Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Tooltip } from "barte-design-system";
interface ChargebackProps {
  handleToggleChargebackModal: () => void;
  ref?: React.MutableRefObject<undefined>;
  amount?: number;
  chargeUuid: string;
}

export function Chargeback({
  handleToggleChargebackModal,
  ref,
  amount,
  chargeUuid,
}: Readonly<ChargebackProps>) {
  const {  hasAntecipationActive } =useAnticipationStatus();
  const { getChargeEligibility } = useCharge();
  const [isEligible, setIsEligible] = useState(false);
  useEffect(() => {
    if (amount && chargeUuid) {
      getChargeEligibility(amount, chargeUuid)
        .then((response) => setIsEligible(!!response.data?.isEligible))
        .catch(() => {
          setIsEligible(false);
          showToast({
            type: "error",
            message:
              "Não foi possível verificar a elegibilidade do estorno. Tente novamente.",
          });
        });
    }
  }, [amount, chargeUuid]);
  return (
    <>
      <Flex flexDir="column" align="flex-start">
        {isEligible ? (
          <Button
            p="0"
            m="0"
            color={hasAntecipationActive ? "newGray.400" : "red.danger"}
            fontSize={hasAntecipationActive ? "14px" : "1rem"}
            disabled={hasAntecipationActive}
            id="excluir_cobrança"
            variant="ghost"
            h="24px"
            maxW="145px"
            transition="filter .2s"
            cursor="pointer"
            _hover={
              !hasAntecipationActive
                ? {
                    transition: "filter .2s",
                    filter: "brightness(.8)",
                    textDecoration: "underline",
                    color: "red.danger",
                  }
                : {}
            }
            onClick={handleToggleChargebackModal}
            isDisabled={!isEligible}
          >
            Estornar cobrança
          </Button>
        ) : (
            <Tooltip label="Não é possível estornar essa transação" placement="top">
              <Button
                p="0"
                m="0"
                color="newGray.400"
                fontSize="14px"
                id="excluir_cobrança"
                variant="ghost"
                h="24px"
                maxW="145px"
                transition="filter .2s"
                cursor="not-allowed"
                isDisabled
              >
                Estornar cobrança
              </Button>
            </Tooltip>
          )}
      </Flex>
    </>
  );
}
